import { observable } from '@/libs/state'
import type { SearchPort } from './domain/search'

const search$ = observable({ isOpen: false })

const searchAdapter: SearchPort = {
	get: () => search$.get(),
	set: state => search$.set(state),
}

export { search$, searchAdapter }
